import siteEquipmentsClient from '@/core/api/site-equipments-service';
import { ISiteEquipmentCustomerDetailDTO } from '@/../client-generator/generated-clients/siteEquipments';
import { Vue, Component } from 'vue-property-decorator';
import SVGLogoPulinetFull from '@/assets/img/logo/logo-pulinet-full.svg';

@Component({
  components: {
    SVGLogoPulinetFull,
  },
})
export default class SiteEquipmentDetailPageAnonymous extends Vue {
  isLoading = true;

  qrCodeId = '';
  siteEquipment: ISiteEquipmentCustomerDetailDTO | null = null;

  get siteEquipmentQRCodeURL() {
    return 'https://images.placeholders.dev/?width=300&height=300&bgColor=%23fff&textColor=%23fff';
  }

  get siteEquipmentTitle() {
    let title = '';
    if (this.siteEquipment?.brandName || this.siteEquipment?.model) {
      title = ` - ${[this.siteEquipment?.brandName, this.siteEquipment?.model].filter(Boolean).join(' ')}`;
    }
    return `${this.siteEquipment?.serialNumber + title}`;
  }

  mounted() {
    this.qrCodeId = this.$route.params.qrCodeId;
    this.fetchDetails();
  }

  async fetchDetails() {
    try {
      this.siteEquipment = await siteEquipmentsClient.detailQrcode(this.qrCodeId);
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        case 404:
          messageError = this.$t('siteEquipmentNotFound').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.isLoading = false;
    }
  }

  backToList() {
    this.$router.push({
      name: 'page-site-equipments',
    });
  }
}
